import Coffe from "./coffe/coffe";
import Houses from "./houses/houses";

export const projects = [
    <Coffe key="1"/>,
    <Houses key="2"/>
];